import { render, staticRenderFns } from "./default.vue?vue&type=template&id=f9031266"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheHeader: require('/vercel/path0/components/TheHeader.vue').default,TheFooter: require('/vercel/path0/components/TheFooter.vue').default,Promotion: require('/vercel/path0/components/partials/Promotion.vue').default,Network: require('/vercel/path0/components/common/Network.vue').default})
